import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const VideoWrapper = styled.div`
  @media print {
    display: none;
  }
`;

export const VideoSectionHeader = styled.h2`
  margin: 0;
  font-weight: ${fromTheme('font_weight_bolder')};
  margin-bottom: ${fromTheme('spacing_medium')};
  color: ${fromTheme('color_text')};
  font-size: ${fromTheme('font_size_heading_4')};
`;

export const Shimmer = styled(`div`)`
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${fromTheme('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${fromTheme('color_button_secondary')} 10%,
    ${fromTheme('color_background_disabled_form_input')} 18%,
    ${fromTheme('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
`;
